/** Properties we use in ReCharge Line Items, Subscriptions, and Address properties fields.
 * See kotlin-backend class with the same name for documentation. */
export enum PropName {
  CatId = "_catId",
  CatName = "_catName",
  AddonPlanType = "addonPlanType",
  IsTrial = "isTrial",
  IsCheckout = "isCheckout",
  ParentId = "_parentId",
  CustomerId = "_customerId",
  UserId = "userId",
  DeliveryDateOverride = "_deliveryDateOverride",
  SubscriptionId = "subscriptionId",
  /** This is used to link a ReCharge shipping addresses with a KatKin ShippingAddress. */
  ShippingAddressId = "shippingAddressId",
  MealPlan = "mealPlan",
  CatsUsingSubscription = "cat_IDs",
  BreederId = "breederId",
  KittenGccfNumber = "kittenGccfNumber",
  KkItemId = "kk_item_id",
  KkSubId = "kk_sub_id",
  KkDeliveryFeeId = "kk_df_id",
  FirstDeliveryDate = "_firstDeliveryDate",
  SetToZero = "setToZero",
  TrialPeriod = "trialPeriod",
  RecurringQuantity = "recurringQuantity",
  ConvertToSub = "convertToSub",
  CatsCheckedOut = "_catsCheckedOut",
  FormUsed = "_formUsed",
  OrderPlaced = "_orderPlaced",
  TrialType = "trialType",
  UserAgent = "_userAgent",
  Fbp = "_fbp",
  Fbc = "_fbc",
  Ip = "_ip",
  Ttp = "_ttp",
  Ttclid = "ttclid",
}
